// VITE_MIGRATION: explicit namespace dep so tool-file transitive imports
// see Sparkle.PageBuilder ready.
import "./namespace.js";

(function () {
  "use strict";

  /*******************************
   * template functions
   */

  //This is set server side
  var TEMPLATES = Sparkle.HandlebarsTemplates,
    COMPONENT_TEMPLATES = {},
    PageBuilder = Sparkle.PageBuilder;

  /**
   * Helper function for loading templates. Can load component or other Page Builder
   * templates.
   **/
  function findTemplate(templateId) {
    var template = TEMPLATES[templateId] || COMPONENT_TEMPLATES[templateId];
    PageBuilder.Helpers.assert(!!template, "No matching template found for template name: " + templateId);
    return template;
  }

  /**
   * Called once in initialize. Compiles handlebar templates and stores them in
   * a private module variable.
   */
  function loadTemplates(components) {
    jQuery.each(components, function (name, component) {
      var template = window.Handlebars.compile(component.template);

      COMPONENT_TEMPLATES[name + "-template"] = function partialCall(context) {
        return template(context);
      };
    });
  }

  //export
  Sparkle.PageBuilder.Templates = {
    TEMPLATES: TEMPLATES,
    findTemplate: findTemplate,
    loadTemplates: loadTemplates,
  };
})();
